module.exports = __webpack_public_path__ + "img/technologyImg1.df9c30bb.png";